import React from 'react';
import { Form, Button, Col, Row, Table } from 'react-bootstrap';
import { copyObject } from '../../../../../../utils';
import styleRules from '../../../../../../utils/styleRules';
import * as _ from 'lodash'
import css from 'glamor'
import { LineItemsValuationT, LineItemValuationT } from '../../../../../../types/Job';
import { initLineItemValuation, lineItemsValuationObj } from '../../../InitObjectJob';
const colors = {
    red: "#cc0000",
    green: "#198c19",
}

export interface IFormValuationProps {
    optionsValuation: LineItemsValuationT
    validation(valid: boolean): void
    onChangeValue(value: LineItemsValuationT): void
    userRole: any
}


const styleValuation = {
    row: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 2fr)',
        gridGap: 5,

    } as React.CSSProperties,
    input: {
        // backgroundColor:"#fff"
    }
}



interface IItemOptionValuationProps {
    label: string
    keyName: string
    onChangeLineItem(key: string, value: any): void
    isValid?: boolean | null
    lineItem: LineItemValuationT
    userRole: any
}

const ItemLineValuation: React.FC<IItemOptionValuationProps> = ({ userRole, keyName, label, onChangeLineItem, isValid, lineItem }): JSX.Element => {
    const [lineItemValuation, setLineItemValuation] = React.useState(initLineItemValuation)
    React.useEffect(() => {
        if (lineItem && (lineItem.accept != undefined || lineItem.reject != undefined) && !_.isEqual(lineItem, lineItemValuation)) {
            setLineItemValuation(lineItem)
        }
    }, [lineItem])

    const onChangeField = (key: 'accept' | 'reject', value: string) => {
        let tempItem = copyObject(lineItemValuation)
        const regex = /^[a-zA-Z]+$/;

        tempItem[key] = (regex.test(value) && value.length <= 3) || value.length <= 0 ? value : tempItem[key];
        setLineItemValuation(tempItem)
        onChangeLineItem(keyName, tempItem)

    }

    return (
        <Form.Group style={styleRules(styleValuation.row, { gridTemplateColumns: 'repeat(3, 2fr) 1fr', textAlign: 'center' })}>
            <div style={{ lineHeight: 3, textAlign: "right" }}><span>{label}</span></div>
            <div>
                <Form.Control
                    className='input-material'
                    disabled={!userRole.includes('client')}
                    onChange={(event) => {
                        let text = event.target.value;
                        onChangeField('accept', text)
                    }}
                    placeholder=""
                    style={styleValuation.input}
                    value={`${lineItemValuation.accept ? lineItemValuation.accept : ''}`}

                />

            </div>
            <div>
                <Form.Control
                    disabled={!userRole.includes('client')}
                    onChange={(event) => {
                        onChangeField('reject', event.target.value)
                    }}
                    className='input-material'
                  
                    placeholder="" 
                    style={styleValuation.input}
                    value={`${lineItemValuation.reject ? lineItemValuation.reject : ''}`}
                />
            </div>
            <div className={isValid ? 'text-success' : 'text-warning'}>
                {isValid ? <i title='Valid' className="fa fa-check" /> : <i title='Required' className="fa  fa-warning " />}
                {/* <Form.Text
                    className=""
                    style={{ color: isValid ? colors.green : colors.red }}
                >
                    {isValid ? 'Valid' : 'InValid'}
                </Form.Text> */}
            </div>
        </Form.Group>
    )
}

const FormValuation: React.FC<IFormValuationProps> = ({ userRole, optionsValuation, onChangeValue, validation }): JSX.Element => {
    const [lineItems, setLineItems] = React.useState(lineItemsValuationObj)
    const [isValid, setIsValid] = React.useState(false);
    const [countValuation, setCountValuation] = React.useState({
        accept: 0,
        reject: 0,
    });
    const isLineItemsValuationInterfaced = (arg: any): arg is LineItemsValuationT => {
        return arg && arg.optionA1 !== undefined;
    }

    React.useEffect(() => {
        if (isLineItemsValuationInterfaced(optionsValuation) && !_.isEqual(optionsValuation, lineItems)) {
            setLineItems(optionsValuation)
            validateItems(optionsValuation)
        }
    }, [optionsValuation])


    const onChangeLineItem = (key: string, value: any) => {
        let tempItems = copyObject(lineItems)
        tempItems[key] = value
        setLineItems(tempItems)
        validateItems(tempItems)
        // update parent 
        onChangeValue(tempItems)
    }

    const validateItems = (items: LineItemsValuationT) => {
        let valid = false;
        let validateData = {
            accept: 0,
            reject: 0,
        }

        Object.keys(items).map((key) => {
            let lineItem: LineItemValuationT = items[key]
            // Matches any characters between a-z or A-Zis and lenght  2 or 3   
            const regex = /^[a-zA-Z]{2,3}/g;
            // (lineItem.accept.length == 2 || lineItem.accept.length == 3)
            if (lineItem.accept && lineItem.accept != '' && regex.test(lineItem.accept) && (!lineItem.reject || lineItem.reject == '')) {
                validateData.accept += 1
            } else if (lineItem.reject && lineItem.reject != '' && regex.test(lineItem.reject) && (!lineItem.accept || lineItem.accept == '')) {
                validateData.reject += 1
            }
        })

        if (validateData.accept == 1 && validateData.reject == 2) {
            valid = true
        }
        setCountValuation(validateData)
        setIsValid(valid)
        // update parent for validation 
        validation(valid)
    }
    return (
        <div style={{ width: "50%" }}>
            {/* <p className="font-weight-bold">Initials are required by the shipper for which of the three options below are accepted and which options are declined.</p> */}
           
            <div style={styleRules(styleValuation.row,{gridTemplateColumns:"29% 2fr 15%",gridGap:0})}>
                <strong>Released Value Option:</strong>
                <div style={styleRules(styleValuation.row,{gridTemplateColumns:"50% 50%",gridGap:0})}>
                <span style={{ textAlign: 'center' }}>Accepted:</span>
                <span style={{ textAlign: 'center' }}>Declined:</span>
                </div>
            </div>


            <ItemLineValuation
                userRole={userRole}
                keyName='optionA1'
                label="Option (A)(1)"
                onChangeLineItem={onChangeLineItem}
                isValid={isValid} lineItem={lineItems.optionA1} />
            <ItemLineValuation
                userRole={userRole}
                keyName='optionA2'
                label="Option (A)(2)"
                onChangeLineItem={onChangeLineItem}
                isValid={isValid} lineItem={lineItems.optionA2} />

            <strong>Full Replacement Cost Option:</strong>
            <ItemLineValuation userRole={userRole}
                keyName='optionB'
                label="Option (B)"
                onChangeLineItem={onChangeLineItem}
                isValid={isValid}
                lineItem={lineItems.optionB} />
            {userRole.includes('client') && countValuation.accept <= 0 && <p className="text-danger" style={{}}>Exactly one (1) option must be approved.</p>}

            {/* <Button>
                Save
            </Button> */}
        </div>
    )
}

export default FormValuation;
export { FormValuation };